<template>
  <sea-page-content
    ref="list"
    :fetchList="fetchList"
    :resetList="resetList"
    :items="items"
    toolbar
    searchPanel
    in-tab
    hide-data-pub
    pulsanteAggiorna
    pulsanteCreaFascicolo
    pulsanteAggiungi
    @pulsanteAggiungiClick="upload"
    pulsanteEdit
    @pulsanteEditClick="edit"
    pulsantePubblica
    pulsanteCronologia
    pulsante-tutti-letti
    pulsanteEliminaDoc
    pulsanteCestino
  >
    <template v-slot:table="{ attrs, height }">
      <v-data-table
        v-model="attrs.selected"
        v-bind="attrs"
        :height="height"
        :headers="headers"
        :items="filteredItems"
        sort-by="descrSintetica"
        dense
        show-select
        @click:row="rowClick"
        @item-selected="itemSelected"
        @update:sort-by="sortBy"
      >
        <template v-slot:item.dataConsegna="{ item }">
          {{ item.dataConsegna | dateFormat }}
        </template>
        <template v-slot:item.dataScadenza="{ item }">
          {{ item.dataScadenza | dateFormat }}
        </template>
        <template v-slot:item.visualizza="{ item }">
          <v-btn
            elevation="2"
            rounded
            x-small
            @click.stop="download(item)"
            :color="colors.primarycolor"
            dark
          >
            Apri
            <v-icon right>mdi-open-in-new </v-icon>
          </v-btn>
        </template>
        <template v-slot:item.visibile="{ item }">
          <check-icon :checked="item.visibile"></check-icon>
        </template>
        <template v-slot:item.statoLettura="{ item }">
          <stato-lettura-azienda :stato="item.statoLettura" />
        </template>
        <template v-slot:item.dettaglio="{ item }">
          <v-badge
            color="red"
            :content="item.annotazioniNuove"
            :value="item.annotazioniNuove && item.annotazioniNuove > 0"
            overlap
          >
            <v-btn
              elevation="2"
              rounded
              x-small
              @click.stop="editItem(item)"
              :color="colors.primarycolor"
              dark
            >
              info
              <v-icon right class="material-icons-outlined">info</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <template v-slot:item.createdBy="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <sea-avatar v-bind="attrs" v-on="on">
                {{
                  getIniziali({
                    nome: item.createdByFirstName,
                    cognome: item.createdByLastName,
                  })
                }}
              </sea-avatar>
            </template>
            {{ item.createdByFirstName }} {{ item.createdByLastName }}
          </v-tooltip>
        </template>

        <template v-slot:header.data-table-select="{ props, on }">
          <div class="d-flex flex-row">
            <v-simple-checkbox
              v-bind="props"
              v-on="on"
              :ripple="false"
            ></v-simple-checkbox>
            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on"> mdi-menu-down </v-icon>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      @click="$refs.list.addRemoveAll()"
                      v-model="attrs.allStates"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-title>Tutti</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-for="(status, index) in attrs.states"
                  :key="index"
                >
                  <v-list-item-action>
                    <v-checkbox
                      @click="$refs.list.addRemoveStatus(status.value)"
                      v-model="status.active"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-title>{{ status.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
    </template>
  </sea-page-content>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mixin from "@/mixin";
import StatoLetturaAzienda from "@/components/StatoLetturaAzienda.vue";

const headers = [
  {
    text: "Tag",
    value: "tags",
    sortable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Titolo",
    value: "descrSintetica",
    class: ["heading", "sort"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Data scadenza",
    value: "dataScadenza",
    sortable: false,
    filterable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Pubblicato",
    value: "visibile",
    align: "center",
    sortable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Data",
    value: "dataConsegna",
    sortable: false,
    filterable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Da",
    value: "createdBy",
    sortable: false,
    filterable: false,
    align: "center",
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Letto",
    value: "statoLettura",
    align: "center",
    sortable: false,
    filterable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Visualizza",
    value: "visualizza",
    sortable: false,
    filterable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Dettaglio",
    value: "dettaglio",
    sortable: false,
    filterable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
];

export default {
  name: "documenti-azienda",
  mixins: [mixin],
  components: { StatoLetturaAzienda },
  data() {
    return {
      file: null,
      headers,
      tags: [],
      allTags: true,
      selectedTags: [],
      currentRow: null,
    };
  },
  methods: {
    sortBy(val) {
      this.headers.forEach((h) => {
        h.class = ["text-little-2"];
        if (h.value === val) h.class.push("sort");
      });
    },
    upload() {
      this.$router.push("/company/documents/azi/new");
    },
    edit() {
      this.$router.push({
        name: "editAziDoc",
        params: { id: this.currentRow.id },
      });
    },
    ...mapActions({
      fetchList: "docsAzi/fetchDocuments",
      resetList: "docsAzi/resetDocuments",
      downloadDocument: "docsAzi/downloadDocument",
      uploadDocument: "docsAzi/uploadDocument",
      send: "docsAzi/uploadDossier",
    }),
    editItem(item) {
      this.$router.push({
        path: "/company/documents/azi/documentDetail",
        query: { id: item.id },
      });
    },
    download(item) {
      this.downloadDocument(item);
    },
    rowClick: function (_, row) {
      row.select(!row.isSelected);
    },
    itemSelected(payload) {
      this.currentRow = payload.value ? payload.item : null;
    },
    confirm() {
      this.$refs.list.openDeleteConfirm();
    },
  },
  computed: {
    ...mapGetters({
      items: "docsAzi/documents",
    }),
    filteredItems() {
      return this.allTags
        ? this.items
        : this.items.filter(
            (item) => this.selectedTags.indexOf(item.descrizione) > -1
          );
    },
  },
  watch: {
    selectedTags() {
      if (this.selectedTags.length == 0) {
        this.allTags = true;
        this.tags.forEach((tag) => {
          tag.active = false;
        });
      } else {
        this.allTags = false;
      }
    },
  },
};
</script>

<style>
</style>
